import moment from 'moment'

export default (date, limit = 3) => {
	const now = moment()
	const diffDate = moment(date)
	const diff = now.diff(diffDate, 'days')
	return diff >= limit ? diffDate.format('DD MMMM YYYY') : diffDate.fromNow()
}
